export default __webpack_public_path__ + "static/media/G0002.0fb40051.png";